import React from 'react';
import Icon from '../../../components/AppIcon';

const RewardsOverviewCard = ({ metrics }) => {
  const stats = [
    {
      label: 'Total Points Distributed',
      value: metrics?.totalPointsDistributed?.toLocaleString() || '0',
      icon: 'Coins',
      color: 'primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Pending Redemptions',
      value: metrics?.pendingRedemptions || '0',
      icon: 'Clock',
      color: 'warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Active Users',
      value: metrics?.activeUsersWeek || '0',
      icon: 'Users',
      color: 'success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Total Users',
      value: metrics?.totalUsers || '0',
      icon: 'UserCheck',
      color: 'accent',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-20">
      {stats?.map((stat, index) => (
        <div key={index} className="bg-card rounded-lg shadow-elevation-2 p-20 hover:shadow-elevation-3 transition-smooth">
          <div className="flex items-start justify-between mb-16">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-8">{stat?.label}</p>
              <p className={`text-3xl font-heading font-bold text-${stat?.color}`}>
                {stat?.value}
              </p>
            </div>
            <div className={`flex items-center justify-center w-12 h-12 ${stat?.bgColor} rounded-lg`}>
              <Icon name={stat?.icon} size={24} color={`var(--color-${stat?.color})`} strokeWidth={2.5} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RewardsOverviewCard;